import { useCallback, useEffect, useRef, useState } from "react"
import { declineReasons } from "../../services/communityService";
import { ApiArrayResponseModel } from "./models/ApiResponseModel";
import { DeclineReasonModel } from "./models/DeclineReasonModel";

export const useDeclineReasons = () => {
    const isMountedRef = useRef(true);
    const [list, setList] = useState<DeclineReasonModel[]>([]);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        }
    }, []);

    const load = useCallback(async () => {
        try {
            const _data: ApiArrayResponseModel<DeclineReasonModel> = await declineReasons();
            if(!isMountedRef.current)
                return;
            setList(_data.results);
        }
        catch {}
        finally {

        }
    }, []);

    useEffect(() => {
        load();
    }, [load]);

    return { list };
}   